export default function LevelBar({ score, levelClass, level }) {
  const safeScore = Math.min(100, Math.max(0, score || 0));

  return (
    <div className="level-gauge">
      <div className="level-gauge__header">
        <span className={`level-gauge__level ${levelClass}`}>{level}</span>
        <span className="level-gauge__score">{safeScore}</span>
      </div>
      <div className="level-gauge__track">
        <div className="level-gauge__zone level-gauge__zone--low" />
        <div className="level-gauge__zone level-gauge__zone--mid" />
        <div className="level-gauge__zone level-gauge__zone--high" />
        <div
          className={`level-gauge__fill ${levelClass}`}
          style={{ width: `${safeScore}%` }}
        />
        <div
          className={`level-gauge__marker ${levelClass}`}
          style={{ left: `${safeScore}%` }}
        />
      </div>
    </div>
  );
}
